import { render, staticRenderFns } from "./FInputWrapper.vue?vue&type=template&id=4c68a2e6&"
import script from "./FInputWrapper.vue?vue&type=script&lang=js&"
export * from "./FInputWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports